import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, ComponentProps, Fragment, useCallback, useContext } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { BreadcrumbsContext } from '../../context/BreadcrumbsContext';
import { IconDeprecated, IconSize, IconType } from '../../misc/IconDeprecated/IconDeprecated';
import { preventEventDefaultHandler } from '../../utils/preventEventDefaultHandler';
import { prepareProps } from '../../utils/propUtils';
import { PropsWithoutChildren } from '../../utils/utilityTypes';
import { classes } from '../../utils/utils';
import styles from './BreadcrumbBar.module.css';
export type BreadcrumbBarProps = PropsWithoutChildren<ComponentProps<'div'>>;
export const BreadcrumbBar: FunctionComponent<BreadcrumbBarProps> = React.memo(props => {
  const $ = _c(15);
  const {
    className,
    ...remainingProps
  } = prepareProps({
    props,
    ignoreChildren: true
  });
  const {
    breadcrumbs
  } = useContext(BreadcrumbsContext);
  const navigate = useNavigate();
  let t0;
  if ($[0] !== navigate) {
    t0 = () => {
      navigate(-1);
    };
    $[0] = navigate;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleBackClick = t0;
  const t1 = classes(className, styles.container);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = classes(styles.iconContainer, styles.backButton);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IconDeprecated name="chevron-left" type={IconType.Light} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== handleBackClick) {
    t4 = <button type="button" className={t2} onClick={handleBackClick}>{t3}</button>;
    $[4] = handleBackClick;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== breadcrumbs) {
    let t6;
    if ($[8] !== breadcrumbs.length) {
      t6 = (crumb, index) => <Fragment key={index}><NavLink to={crumb.to} className={classes(styles.iconContainer, styles.crumb, crumb.disabled ? styles.crumbDisabled : "")} onClick={crumb.disabled ? preventEventDefaultHandler : undefined} data-testid="BreadcrumbBar.crumb"><IconDeprecated name={crumb.iconName} type={crumb.iconType} /></NavLink>{index >= breadcrumbs.length - 1 ? undefined : <div className={styles.iconContainer}><IconDeprecated name="caret-right" type={IconType.Solid} size={IconSize.Small} /></div>}</Fragment>;
      $[8] = breadcrumbs.length;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    t5 = breadcrumbs.map(t6);
    $[6] = breadcrumbs;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[10] !== remainingProps || $[11] !== t1 || $[12] !== t4 || $[13] !== t5) {
    t6 = <div {...remainingProps} className={t1}>{t4}{t5}</div>;
    $[10] = remainingProps;
    $[11] = t1;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
});